import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch2_p08 } from "../../../layouts/ch2_p08/ch2_p08"

export class Chapter2Page8 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch2_p08/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch2_p08/"));
	readonly lines = this.addChild(SceneSprite.withPrefix("ch2_p08/"));
	readonly chairs = this.addChild(new SceneSprite());
	readonly hollyBack = list(() => this.addChild(new SceneSprite()));
	readonly table = this.addChild(new SceneSprite());
	readonly phone = this.addChild(new SceneSprite());
	readonly hollyFront = list(() => this.addChild(new SceneSprite()));
	readonly sigh = this.addChild(new SceneSprite());
	readonly amy = this.addChild(new SceneSprite());
	readonly oscar = this.addChild(new SceneSprite());

	dontScaleUp = true;

	public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
		ch2_p08.call(this);
		this.hollyBack[1].visible = false;
		this.hollyFront[1].visible = false;
		this.sigh.visible = false;

		this.setChildIndex(this.hollyBack[0], this.getChildIndex(this.chairs) + 1);
		this.setChildIndex(this.hollyBack[1], this.getChildIndex(this.chairs) + 1);
		this.setChildIndex(this.hollyFront[0], this.getChildIndex(this.table) + 1);
		this.setChildIndex(this.hollyFront[1], this.getChildIndex(this.table) + 1);

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: () => void) {
		super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {

		const endColour = HLF.Colour.lerp(HLF.Colour.WHITE, HLF.Colour.BLACK, 0.4);

		new TimelineMax()
			.to(this.oscar, 2, {
				pixi: {
					tint: endColour.toHex(),
					scale: this.oscar.scale.x * 1.05,
					x: this.oscar.position.x + 100,
				},
				ease: Expo.easeInOut
			}, 0)
			.to(this.amy, 2, {
				pixi: {
					tint: endColour.toHex(),
					scale: this.amy.scale.x * 1.05,
					x: this.amy.position.x + 100,
				},
				ease: Expo.easeInOut
			}, 0)
			.call(() => {
				this.amy.FadeOut();
				this.oscar.FadeOut();
			}, undefined, undefined, 3)
			.call(() => {
				this.hollyFront[1].FadeIn();
				this.hollyBack[1].FadeIn();
				this.hollyFront[0].FadeOut();
				this.hollyBack[0].FadeOut();
			}, undefined, undefined, 5)
			.fromTo(this.sigh, 2, {
				pixi: {
					x: this.sigh.position.x,
					scale: this.sigh.scale.x * 0.25,
					alpha: 0,
					visible: true,
				},
			}, {
				pixi: {
					x: this.sigh.position.x + 30,
					scale: this.sigh.scale.x,
					alpha: 1,
				},
				ease: Expo.easeInOut,
			}, 4.5)
			.call(() => {
				super.onAnimateInComplete();
			})
			.call(() => {
				this.gotoNextState({ transition: "fade" });
			}, undefined, undefined, "+=1.5")
			.delay(2.5)
			;

		// background music
		const prevLoop = Application.instance.audio.getAudioTrack("HH_Ch2_LoopOnly", HLF.AudioCategory.BGM);
		prevLoop?.fadeTo(0, 1000);
		prevLoop?.once(HLF.HowlerUtils.Events.FADE, () => {
			prevLoop.unloadSource();
		});

		const outro = Application.instance.audio.createAudioTrack("HH_Ch2_OutroElement", HLF.AudioCategory.BGM);
		outro.play();
		outro.setLooped(false);
		outro.once(HLF.HowlerUtils.Events.END, () => {
			outro.unloadSource();
		});
	}
}